import LazyImage, {ImageUrlType} from '@basicComponents/image';
import React, {ReactNode} from 'react';
import {View} from 'react-native';
import theme from '@style';
import {useInnerStyle} from '../proxy.hooks';
// import Text from '@basicComponents/text';
import BoxShadow from '@/components/basic/shadow';
import styles from './index.module.scss';

export interface ProxyRulesTableResult {
  level: string;
  tiers: string[];
}

export interface ProxyRulesParagraphProps {
  titleImage: ImageUrlType;
  paragraphs: string[];
  children?: ReactNode;
}

const ProxyRulesParagraph: React.FC<ProxyRulesParagraphProps> = ({
  titleImage,
  paragraphs,
  children,
}) => {
  const {rulesStyle} = useInnerStyle();
  // console.log('paragraphs>>>>>>>', paragraphs);
  return (
    <BoxShadow
      style={[rulesStyle.paragraphWrap]}
      shadowStyle={{
        radius: theme.borderRadiusSize.xl,
        out: {x: 0, y: 0, blur: 13, color: '#0000001b'},
      }}
      containerStyle={theme.margin.lrl}>
      <div
        style={{
          ...theme.flex.col,
          ...theme.flex.start,
          ...theme.padding.l,
          ...rulesStyle.paragraph,
          ...theme.borderRadius.xl,
        }}
        className={styles.rule_card}>
        <LazyImage
          occupancy="#0000"
          width={theme.iconSize.xl}
          height={theme.iconSize.xl}
          imageUrl={titleImage}
        />
        <View>
          {paragraphs.map((paragraph, index) => (
            <span key={index} className={styles.rule_card_text}>
              {paragraph}
            </span>
          ))}
        </View>
        {children}
      </div>
    </BoxShadow>
  );
};

export default ProxyRulesParagraph;
